import React from 'react'
import { transaction } from "~/redux/user/actions";
import { subscribe } from "~/redux/user/subscription";
import {format} from 'date-fns';
import getSymbolFromCurrency from "currency-symbol-map";
import { getLegalTexts } from "./helper"

class Verify extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  setMonthFormat(month){
    if(month > 9){
      return month
    }
    return `0${month}`
  }

  setYearFormat(year){
    return `${year}`.substr(2)
  }

  subscribe = () => {
    subscribe({
      plan: this.props.plan,
      billingToken: this.props.user.billingInfo,
      offerCode: this.props.offerCode && this.props.offerCode.code
    }).then((data) => {
      this.setState({
        loading: false
      })
      this.props.success(data);
    }).catch(err =>{
      this.setState({
        loading: false,
        error: err.response.data.error
      })
      setTimeout(_ => this.setState({ ...this.state, error: null }), 5000)
    })
  }

  purchase(){
    const data={}
    data.amount = this.props.plan.price
    data.transaction = 'stripe'
    data.stripeToken = this.props.user.billingInfo.stripeToken.card.id
    data.contentRequest = {
      contentType: this.props.content.gist.contentType,
      contentId: this.props.plan.contentID ? this.props.plan.contentID : this.props.plan.videoID,
      videoIds: this.props.plan.videoID,
      seasonId: this.props.plan.seasonId,
      seriesId: this.props.plan.seriesId,
      videoQuality: 'HD' 
    }
    data.purchaseType = this.props.plan.option.toUpperCase()
    data.platform = "web_browser"
    data.siteId = window.settings.siteId
    data.currencyCode = "USD"
    data.requestId = this.props.user.billingInfo.requestId;
    data.userId = this.props.user.userId
    data.email = this.props.user.email
    data.site = window.settings.internalName;
    transaction(data).then(response=>{
      this.props.success(this.props.plan.videoID);
      this.setState({loading: false})
    }).catch(err =>{
      this.setState({
        loading: false,
        error: err.response.data.error
      })
      setTimeout(_ => this.setState({ ...this.state, error: null }), 5000)
    })
  }
  render() {
    if(this.props.user && this.props.user.billingInfo){
      const price = (this.props.plan.price || (this.props.plan.planDetails && this.props.plan.planDetails[0].recurringPaymentAmount))
      const { plan } = this.props
      const pd = plan.planDetails && plan.planDetails[0]
      const  card = this.props.user && this.props.user.billingInfo.stripeToken.card
      return <div className="verify-info">
          <div className="header">
            {this.props.subscription ? <p>Verify your information</p> : <p>Verify your information and {this.props.plan.option}</p>}
            {this.props.firstPayment ? <div className="desc">
              <span className="first-payment">First Payment</span>
              <span className="price">
                &nbsp;
                {getSymbolFromCurrency(pd.recurringPaymentCurrencyCode)}
                {this.props.firstPayment.amount.toFixed(2)}
              </span> (+ tax if req'd) on {format(this.props.firstPayment.nextBillingDate, "MM/DD/YYYY")}
            </div>:
            <p>
              <span className="bold">Payment:</span> ${price.toFixed(2)} will be charged when you click {this.props.subscription ? `Subscribe Now`: `Verify and ${this.props.plan.option}`}
            </p>
            }
            <p>Please verify your information before proceeding.</p>
          </div>
          <div className="verify-details">
            <div className="verify-details-left">
              <p>
              <span className="bold">{this.props.subscription ? `Subscribe` : `${this.props.plan.option}`}</span> (${price.toFixed(2)})
              </p>
            </div>
            <div className="verify-details-center">
            <p><span className="bold">BILLING ADDRESS</span></p>
              <p>{this.props.user.name}</p>
              <p>{card['address_line1']} {card['address_line2']}</p>
              <p>{card['address_city']}, {card['address_country']}, {card['address_zip']}</p>
            </div>
            <div className="verify-details-right">
            <p className="bold card-edit">CARD DETAILS <span className="edit" onClick={this.props.edit}>EDIT</span></p> 
              <p>************{card.last4}</p>
              <p><span className="bold">Expires:</span> {this.setMonthFormat(card['exp_month'])}/{this.setYearFormat(card['exp_year'])}</p>
            </div>
          </div>
          {getLegalTexts(window.settings.internalName, this.props.subscription, this.props.plan.option, window.settings.companyName)}
          <div className="verify-button overlay-button cta" 
            onClick={()=>{
              if(this.state.loading){
                return
              }
              if(this.props.subscription) {
                this.subscribe() 
              }else {
                this.purchase()
              }
              this.setState({loading: true})
            }
          }>
          {this.state.loading ? <p className="processing">Processing<span>.</span><span>.</span><span>.</span></p>:<button>{this.props.subscription ? `Subscribe Now`: `verify and ${this.props.plan.option}`}</button>}
          </div>
        {this.state.error && <p className="site-color error">{this.state.error}</p>}
        </div>;
    } else {
      return <div />
    }
  } 
}

export default Verify;
